import { Key, useMemo } from 'react';

import { Select, SelectProps } from 'antd';

const { Option } = Select;

interface OptionData {
  id: Key;
  name: string;
}

interface ExtSelectSearchProps {
  data?: OptionData[];
  additionalData?: OptionData[];
  optionRender?: (name: string, value: Key) => JSX.Element;
}

export type SelectSearchProps = ExtSelectSearchProps & SelectProps;

export default function SelectSearch({
  data,
  value,
  onChange,
  additionalData,
  optionRender,
  ...props
}: SelectSearchProps) {
  const dataSource = useMemo(() => data, [data]);

  const optionBuilder = ({ id, name }: OptionData) => {
    return (
      <Option key={id} value={id}>
        {optionRender ? optionRender(name, id) : name}
      </Option>
    );
  };

  const mainOptions = dataSource && dataSource.map((opData) => optionBuilder(opData));

  const secondaryOptions = additionalData && additionalData.map((opData) => optionBuilder(opData));

  const allOptions = () => {
    if (secondaryOptions && mainOptions) return secondaryOptions.concat(mainOptions);
    if (mainOptions) return mainOptions;
    return undefined;
  };

  const polimorfValue = (value: any) => {
    if (props.mode === 'multiple') {
      if (Array.isArray(value)) return value;
      return [value];
    }
    const num = Number(value);
    if (isNaN(num)) return value;
    return num;
  };

  return (
    <Select
      allowClear={true}
      showSearch
      value={value ? polimorfValue(value) : undefined}
      onChange={onChange}
      optionFilterProp="children"
      {...props}
    >
      {allOptions()}
    </Select>
  );
}
